import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const JerseyIcon = ({ fill = 'gcBlue', size = 'small' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 64 64"
        >
            <title>Jersey Icon</title>
            <path
                d="M40.998 8.911c.39 0 .776.055 1.133.17l.21.075 10.098 4.437c.214.086.412.201.595.33.425.3.768.705 1.004 1.165l.094.2 5.48 15.662c.389.897.018 1.929-.796 2.44l-.137.109-.075.046-9.6 3.27v17.227c0 1.026-.843 1.877-1.858 1.953L47 56H18c-1.03 0-1.919-.805-1.998-1.812l-.005-.146V36.82l-9.978-3.274c-.38-.173-.65-.472-.85-.807-.29-.484-.401-1.069-.221-1.622l.063-.166 5.33-15.231.16-.431a3.233 3.233 0 0 1 1.482-1.599l.21-.096 10.098-4.437a3.632 3.632 0 0 1 1.346-.245c.998 0 2.033.358 2.745.997l.158.153 5.778 5.989 5.775-5.99c.71-.734 1.828-1.149 2.905-1.149zm0 2c-.522 0-1.049.185-1.367.447l-.098.09-7.214 7.482-7.217-7.479c-.302-.312-.887-.54-1.465-.54-.187 0-.358.024-.47.053l-.071.023-9.827 4.315 3.57 7.14a11 11 0 0 1 1.154 4.525l.007.394V36h-.003v18.042c0-.038.005-.042.005-.043h28.996l.004.015V36.532h-.009v-9.138L47 27c.052-1.451.487-2.906 1.108-4.23l.159-.329 3.483-6.964-.022-.012-10.133-4.453a1.632 1.632 0 0 0-.597-.1zm-29.04 6.241-5.06 14.459-.034.086.01-.002.02.031L16 34.714v-7.353a9 9 0 0 0-.8-3.71l-.15-.315-3.092-6.184zm40.906.566-2.808 5.618-.15.315c-.48 1.058-.836 2.2-.897 3.36l-.009.35v7.341l8.677-2.956.076-.05h.005l-.033-.085-4.861-13.893z"
                className={fillStyles}
                fillRule="nonzero"
            />
        </svg>
    );
};
